import { ref } from "vue";
import { useApiConfig } from "@/composables/useApiConfig.js";
import { useIndexedDb } from "@/composables/useIndexedDb.js";
import { useNow } from "@vueuse/core";

import getNavigation from "@/auto-generated/navigation.json";
import getFooter from "@/auto-generated/footer.json";
import getShared from "@/auto-generated/shared.json";
import getCases from "@/auto-generated/cases.json";

const { sbApi, cv, token, version } = useApiConfig();
const { dbEntry, dbGetAll } = useIndexedDb();
const now = useNow();

const prepareIndexedDb = async () => {
  // clean up old cases
  const allDbCases = await dbGetAll("cases");
  allDbCases.forEach(async (dbCase) => {
    const caseExists = getCases.list.find((_case) => _case.full_slug === dbCase.full_slug);
    if (!caseExists) {
      // delete case from indexed db - it no longer exists on Storyblok
      const dbEntryCase = await dbEntry("cases", dbCase.full_slug);
      dbEntryCase.value = null;
    }
  });

  // update or add cases to indexed db
  getCases.list.forEach(async (_case) => {
    const dbEntryCase = await dbEntry("cases", _case.full_slug);
    const data = {
      full_slug: _case.full_slug,
      uuid: _case.uuid,
      title: _case.title,
      type: _case.type,
      image: _case.featured_image,
      accessible_only_via_link: _case.accessible_only_via_link || false,
      // if an exisitng timestamp is found, use that, otherwise use the current timestamp
      last_visited: dbEntryCase.value?.last_visited || now.value,
    };
    dbEntryCase.value = data;
  });
};

prepareIndexedDb();

const navigation = ref(null);
navigation.value = getNavigation;
const footer = ref(null);
footer.value = getFooter;
const shared = ref(null);
shared.value = getShared;
const cases = ref(null);
cases.value = getCases;

const firstLoad = ref(true);

export function useGlobals() {
  return {
    navigation,
    footer,
    shared,
    cases,
    firstLoad,
  };
}

export function useSetGlobals() {
  const setGlobal = async () => {
    const data = await fetch(`${sbApi}/global/config${cv}${token}${version}`);
    const json = await data.json();
    navigation.value = json.story.content.navigation[0];
    footer.value = json.story.content.footer[0];
    shared.value = json.story.content.shared[0];
  };
  const setFromEditor = (story) => {
    navigation.value = story.navigation[0];
    footer.value = story.footer[0];
    shared.value = story.shared[0];
  };

  // const setLatestNews = async (num) => {
  //   if (latestNewsOnce) {
  //     const data = await fetch(
  //       `${sbApi}${cv}&per_page=${num}&filter_query[component][in]=t-news-article&sort_by=content.date:desc${token}${version}`
  //     );
  //     const json = await data.json();
  //     latestNews.value = json.stories;
  //     latestNewsOnce.value = false;
  //   }
  // };

  const splitToChunks = (array, parts) => {
    let result = [];
    for (let i = parts; i > 0; i--) {
      result.push(array.splice(0, Math.ceil(array.length / i)));
    }
    return result;
  };

  // const setInterests = async () => {
  //   if (interestsOnce.value) {
  //     const data = await fetch(
  //       `${sbApi}${cv}&per_page=25&filter_query[component][in]=t-interests-article${token}${version}`
  //     );
  //     const json = await data.json();
  //     const interests = splitToChunks(json.stories, 2);
  //     interestsOne.value = interests[0];
  //     interestsTwo.value = interests[1];
  //     interestsOnce.value = false;
  //   }
  // };

  return {
    setGlobal,
    setFromEditor,
  };
}
